const getContainerBorder = removeQtySelect => (
  removeQtySelect ? false : { size: 'xsmall', color: '#E0E0E0', side: 'all' }
)

export default getContainerBorder
